module.exports = __webpack_public_path__ + "03_long_black.d22e05a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/03_long_black.png
// module id = sv6P
// module chunks = 0